<div class="bread-crumb">
    <div class="wrapper">
      <div class="btn-ir" (click)="backClicked()" *ngIf="!showBtnBack">
        <div class="btn-back">            
            <app-icon [Path]="'./assets/img/ico_back.svg'"></app-icon>
        </div>
      </div>
      <div class="rutas">
        <ul>
          <ng-content select="[rutas-bread]"></ng-content>
        </ul>
      </div>
    </div>
  </div>
  